/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Site';
export const filterTitle = t`Site`;
export const entityType = ENTITY_TYPES.SITE;

export function useSite() {
    return useEntity(filterId);
}

export function useSiteName() {
    return useEntityName(filterId);
}

function SiteFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

SiteFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

SiteFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/site-detail',
                pageStateParams: ['SelectedTime'],
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(SiteFilter);
